import {
  CheckCircleOutline,
  ErrorOutline,
  ErrorOutlineOutlined,
  SignalCellular3BarOutlined,
  SignalCellular4BarOutlined,
  SignalCellular2BarOutlined,
  SignalCellular1BarOutlined,
  SignalCellularNodataOutlined,
  WarningAmberOutlined,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellularConnectedNoInternet4Bar,
  SignalCellular0BarOutlined,
} from "@mui/icons-material";
import { useOutletContext } from "react-router-dom";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useMapa } from "../../../contexts/mapaContext";
import { elements } from "chart.js";

// semDados: ONU sem leitura de rx nem tx (ERP e Zabbix sem dado) — distinto de
// "offline" (-40)
export default function StatusPot({ potenciaRx, color, semDados = false }) {
  const theme = useTheme();
  const { config } = useOutletContext();
  const [nivel, setnivel] = useState(0);

  const styles = {
    icons: {
      color: color,
      fontSize: "20px",
    },
    info: {
      color: theme.palette.color.textDisabled,
      width: "100%",
    },
    statusCard: {
      backgroundColor: "transparent",
      paddingX: "10px",
      paddingY: "0px",
      display: "flex",
      gap: 2,
      height: "60px",
    },
    line: { backgroundColor: "#FFFFFF", width: "3px", height: "100%" },
  };

  const niveis = [
    {
      icon: <SignalCellular0BarOutlined sx={styles.icons} />,
      text: "Sinal Offline, sem recepção de sinal",
    },

    {
      icon: <SignalCellular4BarOutlined sx={styles.icons} />,
      text: "A recepção  do sinal está em condições excelentes",
    },
    {
      icon: <SignalCellular3BarOutlined sx={styles.icons} />,
      text: "A recepção do sinal está em boas condições",
    },
    {
      icon: <SignalCellular2BarOutlined sx={styles.icons} />,
      text: "A recepção do sinal está razoável, apresentando qualidade moderada",
    },
    {
      icon: <SignalCellular1BarOutlined sx={styles.icons} />,
      text: "A recepção do sinal está ruim e instável",
    },
  ];
  useEffect(() => {
    const ftthEscalaNum = config?.configuracoes?.ftth?.camadaFTTH?.escala ?? [];
    const position = ftthEscalaNum.findIndex((item) => color === item.cor);
    setnivel(position !== -1 ? position : 0);
  }, [config]);

  const atual = semDados
    ? {
        icon: <SignalCellularNodataOutlined sx={styles.icons} />,
        text: "Sem leitura de potência para esta ONU",
      }
    : niveis[nivel];

  return (
    <Paper sx={styles.statusCard} elevation={0} variant="miniCards">
      <Stack direction={"column"} width={"100%"} gap={0.5}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography variant="default">{"Status da potência"}</Typography>
          {atual?.icon}
        </Stack>
        {
          <Typography sx={styles.info} variant="small">
            {atual?.text}
          </Typography>
        }
      </Stack>
    </Paper>
  );
}
